module.exports = __webpack_public_path__ + "static/img/emptyData.d277f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/emptyData.png?v1232
// module id = 542
// module chunks = 3 4 5 6